<template>
  <div v-loading="loading">
    <div class="c_page-title">
      <div>点货单详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div class="blockinfo">
      <el-row v-if="resData">
        <el-col :span="6">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>点货单ID：</span>
                <span>{{ resData.pici_id }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>类型：</span>
                <span>{{ resData.type_txt }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>包裹号：</span>
                <a
                  :href="`#/home/supply/package-list?pici=${resData.pici_no}`"
                  target="_blank"
                  class="buttonText"
                  >{{ resData.package_no }}</a
                >
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>批次号：</span>
                <span>{{ resData.pici_no }}</span>
                <img
                  :src="
                    'http://erp.yishouapp.com/barcode.php?text=' +
                    resData.pici_no
                  "
                  style="width: 150px; vertical-align: middle"
                />
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>代采组：</span>
                <span>{{ resData.pgname }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>包裹生成时间：</span>
                <span>{{ resData.package_create_time }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>创建人：</span>
                <span>{{ resData.admin_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="info-row">
                <span>商家：</span>
                <span>{{ resData.supply_name }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-row">
                <span>仓库：</span>
                <span>{{ resData.origin_txt }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span>创建时间：</span>
                <span>{{ resData.create_time }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="info-row">
                <span v-if="resData && resData.package_img"
                  >收包图片({{ resData.package_img.length }})：</span
                >
                <span>
                  <div
                    v-viewer
                    style="
                      width: 40px;
                      height: 40px;
                      overflow: hidden;
                      cursor: pointer;
                      display: inline-block;
                      vertical-align: text-top;
                    "
                  >
                    <img
                      v-for="(item, index) in resData.package_img"
                      :key="index"
                      :src="item"
                      style="width: 100%; height: 100%; vertical-align: middle"
                    />
                  </div>
                </span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>差异审核</div>
      </div>
      <el-table :data="resData.pici_goods_data" border style="width: 100%">
        <el-table-column prop="goods_eff_num" label="有效商品" align="center">
        </el-table-column>
        <el-table-column prop="goods_inv" label="不良品" align="center">
        </el-table-column>
        <el-table-column prop="no_data_num" label="无数据商品" align="center">
        </el-table-column>
        <el-table-column
          prop="no_data_num_goods"
          label="其中:无数据点货"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="recall_num" label="撤标商品" align="center">
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" width="200px">
          <template slot-scope="scope">
            <el-input
              v-model="chayiRemarks"
              type="textarea"
              placeholder="请填写备注"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>有效商品（{{ effGoods.total }}）</div>
        <el-form
          :inline="true"
          :model="filteredEffGoods"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item>
            <el-input
              v-model.trim="filteredEffGoods.goods_name"
              placeholder="商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model.trim="filteredEffGoods.goods_no"
              placeholder="商品货号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model.trim="filteredEffGoods.sku"
              placeholder="sku"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEffGoods">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="effGoods.data" border style="width: 100%" height="400">
        <el-table-column prop="dbrid" label="打标编号" align="center">
        </el-table-column>
        <!-- <el-table-column prop="supply_name" label="商家" align="center">
        </el-table-column> -->
        <el-table-column prop="pgname" label="代采组" align="center">
        </el-table-column>
        <el-table-column prop="goods_img" label="商品图片" align="center">
          <template slot-scope="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                v-for="(item, index) in scope.row.goods_img"
                :key="index"
                :src="item"
                style="width: 100%; height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goods_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="goods_no" label="商品货号" align="center">
        </el-table-column>
        <el-table-column prop="co_val" label="颜色" align="center">
        </el-table-column>
        <el-table-column prop="si_val" label="尺码" align="center">
        </el-table-column>
        <el-table-column prop="sku" label="sku" align="center">
        </el-table-column>
        <el-table-column prop="market_price" label="代采价" align="center">
        </el-table-column>
        <el-table-column prop="dbid" label="打标ID" align="center">
        </el-table-column>
        <el-table-column prop="type_text" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="admin_name" label="打标人" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="打标时间" align="center">
        </el-table-column>
      </el-table>
      <div style="text-align: right; padding: 25px">
        <el-pagination
          :current-page.sync="effGoods.current_page"
          background
          layout="total, prev, pager, next, jumper "
          :total="effGoods.total"
          :page-size="10"
          @current-change="getEffGoods"
        >
        </el-pagination>
      </div>
    </div>
    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>不良品商品（{{ invalidGoods.total }}）</div>
        <el-form
          :inline="true"
          :model="filteredInvalidGoods"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item>
            <el-input
              v-model.trim="filteredInvalidGoods.goods_name"
              placeholder="商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model.trim="filteredInvalidGoods.goods_no"
              placeholder="商品货号"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model.trim="filteredInvalidGoods.sku"
              placeholder="sku"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getInvalidGoods">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <el-table :data="invalidGoods.data" border style="width: 100%" height="400" v-if="invalidGoods && invalidGoods.data.length > 0"> -->
      <el-table
        :data="invalidGoods.data"
        border
        style="width: 100%"
        height="400"
      >
        <el-table-column prop="dbrid" label="打标编号" align="center">
        </el-table-column>
        <!-- <el-table-column prop="supply_name" label="商家" align="center">
        </el-table-column> -->
        <el-table-column prop="pgname" label="代采组" align="center">
        </el-table-column>
        <el-table-column prop="goods_img" label="商品图片" align="center">
          <template slot-scope="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                v-for="(item, index) in scope.row.goods_img"
                :key="index"
                :src="item"
                style="width: 100%; height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goods_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="goods_no" label="商品货号" align="center">
        </el-table-column>
        <el-table-column prop="co_val" label="颜色" align="center">
        </el-table-column>
        <el-table-column prop="si_val" label="尺码" align="center">
        </el-table-column>
        <el-table-column prop="sku" label="sku" align="center">
        </el-table-column>
        <el-table-column prop="market_price" label="代采价" align="center">
        </el-table-column>
        <el-table-column prop="dbid" label="打标ID" align="center">
        </el-table-column>
        <el-table-column prop="type_text" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="blp_note" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="admin_name" label="打标人" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="打标时间" align="center">
        </el-table-column>
      </el-table>
      <div style="text-align: right; padding: 25px">
        <el-pagination
          :current-page.sync="invalidGoods.current_page"
          background
          layout="total, prev, pager, next, jumper "
          :total="invalidGoods.total"
          :page-size="10"
          @current-change="getInvalidGoods"
        >
        </el-pagination>
      </div>
    </div>

    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>无数据商品（{{ noDataGoods.num }}）</div>
      </div>
      <!-- <el-table :data="invalidGoods.data" border style="width: 100%" height="400" v-if="invalidGoods && invalidGoods.data.length > 0"> -->
      <el-table
        :data="noDataGoods.list"
        border
        style="width: 100%"
        height="400"
      >
        <el-table-column prop="ndgid" label="无数据标id" align="center">
        </el-table-column>
        <el-table-column prop="img" label="点货标" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.co_val }}/{{ scope.row.si_val }}</div>
            <div>{{ scope.row.goods_no }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="stock_source" label="入库类型" align="center">
        </el-table-column>
        <el-table-column prop="img" label="商品图片" align="center">
          <template slot-scope="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                v-for="(item, index) in scope.row.middle_img"
                :key="index"
                :src="item"
                style="width: 100%; height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pgname" label="代采组" align="center">
        </el-table-column>
        <el-table-column prop="dbid" label="打标id" align="center">
        </el-table-column>
        <el-table-column prop="admin_name" label="创建人" align="center">
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center">
        </el-table-column>
      </el-table>
      <div style="text-align: right; padding: 25px">
        <el-pagination
          :current-page.sync="noDataGoods.current_page"
          background
          layout="total, prev, pager, next, jumper "
          :total="noDataGoods.total"
          :page-size="10"
          @current-change="getNoDataGoods"
        >
        </el-pagination>
      </div>
    </div>
    <div style="margin-bottom: 20px">
      <div class="card-title">
        <div>撤标商品（{{ recallBiao.count }}）</div>
      </div>
      <el-table :data="recallBiao.data" border style="width: 100%" height="400">
        <el-table-column prop="dbid" label="打标id" align="center">
        </el-table-column>
        <!-- <el-table-column prop="supply_name" label="商家" align="center">
        </el-table-column> -->
        <el-table-column prop="pgname" label="代采组" align="center">
        </el-table-column>
        <el-table-column prop="goods_img" label="商品图片" align="center">
          <template slot-scope="scope">
            <div
              v-viewer
              style="
                width: 40px;
                height: 40px;
                overflow: hidden;
                cursor: pointer;
                display: inline-block;
              "
            >
              <img
                v-for="(item, index) in scope.row.goods_img"
                :key="index"
                :src="item"
                style="width: 100%; height: 100%"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goods_no" label="商品货号" align="center">
        </el-table-column>
        <el-table-column prop="co_val" label="颜色" align="center">
        </el-table-column>
        <el-table-column prop="si_val" label="尺码" align="center">
        </el-table-column>
        <el-table-column prop="sku" label="sku" align="center">
        </el-table-column>
        <el-table-column prop="market_price" label="代采价" align="center">
        </el-table-column>
        <el-table-column prop="recall_type" label="撤标类型" align="center">
        </el-table-column>
        <el-table-column prop="create_admin_name" label="打标人" align="center">
        </el-table-column>
        <el-table-column prop="create_time" label="打标时间" align="center">
        </el-table-column>
      </el-table>
      <div style="text-align: right; padding: 25px">
        <el-pagination
          :current-page.sync="recallBiao.current_page"
          background
          layout="total, prev, pager, next, jumper "
          :total="recallBiao.count"
          :page-size="10"
          @current-change="getRecallBiaoFun"
        >
        </el-pagination>
      </div>
    </div>
    <div>
      <div class="card-title">
        <div>操作日志</div>
        <el-button
          type="text"
          style="margin-left: auto"
          :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          @click="toggleFilter"
          >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
        >
      </div>
      <el-collapse-transition>
        <div v-show="!filterFold">
          <el-table
            v-if="operationLog"
            :data="operationLog.list"
            border
            style="width: 100%"
            height="400"
          >
            <el-table-column prop="operator_name" label="操作人" align="center">
            </el-table-column>
            <el-table-column prop="action_value" label="操作" align="center">
            </el-table-column>
            <el-table-column prop="create_date" label="操作时间" align="center">
            </el-table-column>
          </el-table>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import { getRecallBiao } from "@/controller/pici.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        chayi_img: [],
        pici_img: [],
        pici_goods_data: [],
      },
      chayi_textarea: "",
      textarea: "",
      loading: false,
      files: [],
      dialogTableVisible: false,
      operationLog: null,
      dialogGoods: null,
      editable: false,
      index: null,
      paytime: "",
      initData: "",
      effGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 有效商品
      invalidGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 无效商品
      noDataGoods: {
        data: [],
        total: 0,
        current_page: 1,
      }, // 无数据商品
      recallBiao: {
        data: [],
        count: 0,
        current_page: 1,
      }, // 撤标商品
      filterFold: false, // 日志折叠判断字段
      filteredEffGoods: {}, // 有效商品的筛选条件
      filteredInvalidGoods: {}, // 无效商品的筛选条件
      isEdit: 0, // 判断是否为修改
      goodsNum: "", // 货品总数量
      parcelNum: "", // 包裹数量
      remarks: "", // 备注
      chayiRemarks: "", // 差异备注
      chayiImg: [], // 差异图片
      piciImg: [], // 批次图片
    };
  },
  computed: {
    // filteredFiles() {
    //   let arr = [];
    //   this.files.forEach(v => {
    //     arr.push(v.response.data.files[0]);
    //   });
    //   return arr;
    // },
    chayi_img() {
      const arr = [];
      let str = "";
      this.chayiImg.forEach((v) => {
        arr.push(v.response.data.files[0]);
      });
      str = arr.join(",");
      return str;
    },
    pici_img() {
      const arr = [];
      let str = "";
      this.piciImg.forEach((v) => {
        arr.push(v.response.data.files[0]);
      });
      str = arr.join(",");
      return str;
    },
  },
  methods: {
    getRecallBiaoFun() {
      getRecallBiao({
        pici_id: this.$route.params.id,
        page: this.recallBiao.current_page,
      }).then((data) => {
        const { list, count } = data;
        this.recallBiao.data = list;
        this.recallBiao.count = count;
      });
      this.$forceUpdate();
    },
    getEffGoods() {
      const url = "/erp/pici/getDaBiao";
      this.filteredEffGoods.is_eff = 1;
      this.filteredEffGoods.pici_id = this.$route.params.id;
      this.filteredEffGoods.page = this.effGoods.current_page;
      this.$http.post(url, this.filteredEffGoods).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.effGoods = res.data.data;
        }
      });
    },
    getInvalidGoods() {
      const url = "/erp/pici/getDaBiao";
      this.filteredInvalidGoods.is_eff = 0;
      this.filteredInvalidGoods.pici_id = this.$route.params.id;
      this.filteredInvalidGoods.page = this.invalidGoods.current_page;
      this.$http.post(url, this.filteredInvalidGoods).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.invalidGoods = res.data.data;
        }
      });
    },
    getNoDataGoods() {
      const url = "/erp/pici/getDaBiao";
      this.$http
        .post(url, {
          is_eff: 2,
          pici_id: this.$route.params.id,
          page: this.noDataGoods.current_page,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.noDataGoods = res.data.data;
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },

    uploadPiciImg(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        // this.files = this.files.concat(res.data.files);
        this.piciImg = fileList;
      }
    },
    uploadChayiImg(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        // this.files = this.files.concat(res.data.files);
        this.chayiImg = fileList;
      }
    },
    fetchData(val) {
      if (val) {
        this.loading = true;
      }
      const url = "/erp/pici/info";
      const args = {
        pici_id: this.$route.params.id,
      };
      this.isEdit = this.$route.query.edit;
      this.$http.post(url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          console.log(this.resData.pici_goods_data);
          this.goodsNum = res.data.data.goods_num;
          this.parcelNum = res.data.data.package_num;
          this.remarks = res.data.data.remark;
          this.chayiRemarks = res.data.data.chayi_remark;
        }
        this.loading = false;
      });
      this.$http
        .post("/erp/pici/getDaBiao", {
          is_eff: 1,
          pici_id: this.$route.params.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.effGoods = res.data.data;
          }
        });
      this.$http
        .post("/erp/pici/getDaBiao", {
          is_eff: 0,
          pici_id: this.$route.params.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.invalidGoods = res.data.data;
          }
        });
      this.$http
        .post("/erp/pici/getDaBiao", {
          is_eff: 2,
          pici_id: this.$route.params.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.noDataGoods = res.data.data;
          }
        });
      this.$http
        .post("/erp/OperateLog/getLogList", {
          action_key: "StoragePiciLog",
          object_id: this.$route.params.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.operationLog = res.data.data;
          }
        });
      this.getRecallBiaoFun(); // 撤标商品
    },
    removePici(file, fileList) {
      const index = this.piciImg.indexOf(file.response.data.files[0]);
      if (index > -1) {
        this.piciImg.splice(index, 1);
      }
    },
    removeChayi(file, fileList) {
      const index = this.chayiImg.indexOf(file.response.data.files[0]);
      if (index > -1) {
        this.chayiImg.splice(index, 1);
      }
    },
    handleExceed(files, fileList) {
      this.$message.error("最多只能选择3个文件");
    },
    // 切换页码
    handleNoDataPage(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title .el-form-item {
  margin-bottom: 0;
}

.highlight {
  color: red;
}

.blockinfo {
  /* border-top: 1px solid #ddd; */
  border-bottom: 1px solid #ddd;
  padding: 0 10px 20px;
  margin-bottom: 20px;
}

.info-row {
  color: #666;
  font-size: 14px;
}

.info-row > span:first-child {
  color: #333;
}

.order-log {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/TallyingDetail.vue